export const isElectron = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    return userAgent.toLowerCase().indexOf(' electron/') > -1
}
